/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./othertask.vue?vue&type=template&id=046c457e&scoped=true"
import script from "./othertask.vue?vue&type=script&lang=js"
export * from "./othertask.vue?vue&type=script&lang=js"
import style0 from "./othertask.vue?vue&type=style&index=0&id=046c457e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c457e",
  null
  
)

export default component.exports